import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsEnum, IsUUID } from 'class-validator';
import { OffsetPaginationQueryDto } from '@sphere/shared/domain';

export class ListLearningPathsDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par visibilité',
    enum: ['PRIVATE', 'ESTABLISHMENT', 'PUBLIC'],
  })
  @IsOptional()
  @IsEnum(['PRIVATE', 'ESTABLISHMENT', 'PUBLIC'])
  visibility?: 'PRIVATE' | 'ESTABLISHMENT' | 'PUBLIC';

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par identifiant d\'établissement',
  })
  @IsOptional()
  @IsUUID()
  establishmentId?: string;

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par identifiant externe de matière',
  })
  @IsOptional()
  @IsUUID()
  subjectExternalId?: string;

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par identifiant externe de niveau de classe',
  })
  @IsOptional()
  @IsUUID()
  classLevelExternalId?: string;

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par identifiant de l\'auteur',
  })
  @IsOptional()
  @IsUUID()
  authorUserId?: string;
}

